import React from "react";
import Main from "./main";


export default function TrendingBooks() {
    return (
        <div className="trending">
            <center>
                <div className="category--head">TRENDING BOOKS</div>
                <Main />
            </center>
            
        </div>
    )
}